import React from "react";
import { Star, Quote } from "lucide-react";

const HeroTestimonial = () => {
  return (
    <section className="py-8 bg-neutral-50 border-y border-neutral-200" data-testid="hero-testimonial">
      <div className="max-w-[1280px] mx-auto px-5 md:px-10">
        <div className="flex items-start md:items-center gap-4 md:gap-6 flex-col md:flex-row">
          <Quote size={26} className="text-amber-500 shrink-0"/>
          <p className="text-neutral-800 italic text-[15px] md:text-base leading-relaxed flex-1">
            &ldquo;Sinds we het IT Support-abonnement hebben, hoeven we nergens meer naar om te kijken.&rdquo;
          </p>
          <div className="flex items-center gap-3 shrink-0">
            <div className="flex items-center gap-0.5">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={13} className="fill-amber-400 text-amber-400"/>
              ))}
            </div>
            <div className="text-xs text-neutral-600 leading-tight">
              <div className="font-semibold text-neutral-900">Familie De Bruin</div>
              <div className="text-neutral-500">IT Support klant</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroTestimonial;
